var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.thing.isOffline || _vm.unit.isOffline)?_c('v-alert',{staticClass:"mb-0",attrs:{"tile":"","dense":"","type":"error","color":"error"}},[_vm._v(" "+_vm._s(this.$t('component.unitAlerts.offline'))+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }